<template>
  <div>
    <vue-headful
      title="Personal Information | Gradely.ng - School"
      description="Description goes here"
    />

    <div class="settings-display-layout white rounded-10">
      <!-- PAGE TITLE -->
      <div class="page-title">Personal Information</div>

      <!-- PERSONAL PROFILE CARD COMPONENT -->
      <PersonalProfileCard
        :fullname="getAuthUser.full_name"
        :avatar_img="getAuthUser.image"
        @photoObject="sendPhotoData($event)"
      ></PersonalProfileCard>
      <!-- PERSONAL PROFILE CARD COMPONENT -->

      <!-- PERSONAL PROFILE FORM COMPONENT -->
      <SchoolPersonalProfileForm :photo_image="image"></SchoolPersonalProfileForm>
      <!-- PERSONAL PROFILE FORM COMPONENT -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PersonalProfileCard from "@/components/globalComps/SettingsComps/ProfileComps/PersonalProfileCard";

export default {
  name: "SchoolSettingsUserEdit",

  props: ["photo_data"],

  components: {
    PersonalProfileCard,
    SchoolPersonalProfileForm: () =>
      import(/* webpackChunkName: "SchoolPersonalProfileForm" */ "@/components/globalComps/SettingsComps/ProfileComps/SchoolPersonalProfileForm")
  },

  computed: {
    ...mapGetters(["getAuthUser"])
  },

  data() {
    return {
      image: null
    };
  },

  methods: {
    sendPhotoData($event) {
      this.image = $event;
    }
  }
};
</script>

<style>
</style>
